import React from "react";

const Posts = ({ skillArea }) => {
  return (
    <section className="posts" aria-labelledby="posts-title">
      <div className="container">
        <div className="section-head">
          <h2
            id="posts-title"
            dangerouslySetInnerHTML={{
              __html: skillArea?.thinking_header_html,
            }}
          ></h2>

          <a href="/blog" className="posts-viewall">
            View all posts &rarr;
          </a>
        </div>

        <div className="posts-grid">
          {skillArea?.related_posts?.map((post) => (
            <a key={post.id} href={post.url} className="post-card">
              <div className="post-cover">
                <div className="cover-placeholder">
                  <img src={post?.hero_image_url} alt="" loading="lazy" />
                </div>
              </div>

              <div className="post-body">
                {post.published_at && (
                  <span className="post-date">
                    {new Date(post.published_at).toDateString()}
                  </span>
                )}

                <h3 className="post-title">{post.title}</h3>

                <p className="post-desc">{post.excerpt}</p>

                <span className="post-cta">Read post &rarr;</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Posts;
